import { UsersService } from "@/clients/services/UsersService";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { getDeviceTimezone } from "./get-device-timezone";

let lastSynced: string | null = null;

/**
 * Fire-and-forget: report the device's IANA timezone to the backend so
 * day boundaries (plan days, balance, streaks) follow the user's local day
 * instead of the Europe/London default.
 *
 * Intentionally silent on every failure (no user, offline, 4xx/5xx) — the
 * backend falls back to Europe/London until the next successful send. Called
 * on launch, on foreground, and at onboarding completion; the write is
 * idempotent, and re-sending is what picks up users who travel.
 */
export const syncDeviceTimezone = async (): Promise<void> => {
  try {
    const user = guardGetUserFromLocalStorage();
    const timezone = getDeviceTimezone();
    if (!timezone) return;

    const syncKey = `${user.id}:${timezone}`;
    if (syncKey === lastSynced) return;

    await UsersService.updateTimezoneApiV1UsersTimezonePatch(user.id, { timezone });
    lastSynced = syncKey;
  } catch {
    // Silent by design: nothing user-facing, no retry.
  }
};
